import Datapoint from 'owa-service/lib/contract/Datapoint';
import DatapointConsumer from 'owa-service/lib/contract/DatapointConsumer';
import logDatapointOperation from 'owa-service/lib/operation/logDatapointOperation';

const AlchemyLogDatapointId = 'IncidentProactiveMessaging';

export interface AlchemyDataPointProps {
    alchemyId?: string;
    clientContext: string;
    locale: string;
    alchemyBucketId: string;
}

export default function sendAlchemyDataPoint(
    datapointProps: AlchemyDataPointProps
): Promise<boolean> {
    const keys: string[] = ['alid', 'alcc', 'alloc', 'albi'];

    let values: string[] = [
        datapointProps.alchemyId,
        datapointProps.clientContext,
        datapointProps.locale,
        datapointProps.alchemyBucketId,
    ];

    let alchemyLogDatapoint: Datapoint = {
        Id: AlchemyLogDatapointId,
        Consumers: DatapointConsumer.Analytics,
        Time: new Date(Date.now()).toString(),
        Keys: keys,
        Values: values,
    };

    return logDatapointOperation({ datapoints: [alchemyLogDatapoint] });
}
